module.exports = __webpack_public_path__ + "img/silver.back.2341ea62.png";